export default {

    getTimeDiff() {
        return new Date().getTimezoneOffset() / 60;
    }
    
}